import React from 'react';

const RedirectMessage = ({
  showContinueButton = false,
  handleContinueRedirect = null,
  buttonText = 'Continue',
  containerStyle = {},
  buttonStyle = {}
}) => {
  if (!showContinueButton || !handleContinueRedirect) {
    return null;
  }

  const defaultButtonStyle = {
    backgroundColor: '#0071ce',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '6px',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    minWidth: '160px',
    ...buttonStyle
  };

  const defaultContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20px',
    ...containerStyle
  };

  return (
    <div style={defaultContainerStyle}>
      <button
        onClick={handleContinueRedirect}
        style={defaultButtonStyle}
        onMouseOver={(e) => {
          e.target.style.opacity = '0.8';
        }}
        onMouseOut={(e) => {
          e.target.style.opacity = '1';
        }}
      >
        {buttonText}
      </button>
    </div>
  );
};

export default RedirectMessage;
